<template>
    <div class="container">
        <div class="row">
            <div class="col s12">
                <div class="card-panel">
                    <h4 v-if="user">Warranty information of {{ user.name }}</h4>
                    <div class="row" v-if="syncPosItems">
                        <div class="col s12 right-align">
                            <a class="waves-effect waves-light btn-small" v-on:click="syncData" v-if="!is_sync_loading"><i class="material-icons">sync</i></a>
                            <a class="btn-small disabled" v-if="is_sync_loading"><i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i></a>
                        </div>
                    </div>

                    <table class="striped centered responsive-table">
                        <thead>
                        <tr>
                            <th>Model Number</th>
                            <th>Location</th>
                            <th>Status</th>
                            <th>Action</th>

                        </tr>
                        </thead>
                        <tbody>
                        <tr v-if="warranties" v-for="warranty in warranties">
                            <td>{{ warranty.product_model.name }}
                                <span v-if="warranty.purchaser != null">
                                     <span v-if="warranty.purchaser.is_senheng > 0"><br>For purchases below RM500 from SenHeng, please refer to SenHeng warranty claim policy at <br><a href="https://www.senheng.com.my/plusone-warranty" target="_blank">https://www.senheng.com.my/plusone-warranty</a><br></span>
                                </span>
                                <span v-if="warranty.pos_sale_item_id == null && warranty.status === 0">
                                    <span v-if="warranty.invoice_img == null || warranty.purchase_from_id == 0" class="red-text" style="font-size: 11px;"><br>Incomplete submission. Manual checking needed.</span>
                                </span>
                            </td>
                            <td>{{ warranty.purchaser == null ? 'Not Available' : warranty.purchaser.name }}</td>
                            <td v-html="warranty.warranty_status"></td>
                            <td>
                                <a :data-target="'viewModal' + warranty.id" v-on:click.prevent="showViewModal(warranty)" class="waves-effect waves-light btn-small modal-trigger">View</a>
                                <span v-if="warranty.pos_sale_item_id == null">
                                     <a v-if="warranty.status == 2 && user" :href="warranty.edit_warranty_url" class="waves-effect waves-light btn-small orange">Edit</a>
                                    <a v-if="warranty.status == 0 && user && warranty.invoice_img === null" :href="warranty.edit_warranty_url" class="waves-effect waves-light btn-small orange">Edit</a>
                                </span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <!-- Modal Structure -->
        <div :id="'viewModal' + mutable_selected_warranty.id" :ref="'viewModal' + mutable_selected_warranty.id" v-if="mutable_selected_warranty" class="modal view-modal">
            <div class="modal-content">
                <div ref="printInvoice" class="row">
                    <span v-if="mutable_selected_warranty.pos_sale_item_id == null && mutable_selected_warranty.status == 0">
                        <div v-if="mutable_selected_warranty.invoice_img == null || mutable_selected_warranty.purchase_from_id == 0" class="red-text col s12" style="font-size: 11px;"><br>Incomplete submission. Manual checking needed.</div>
                    </span>
                    <div class="col s12">
                        <h4 class="green-text">{{ mutable_selected_warranty.product_model.name }}</h4>
                    </div>
                    <div class="col s12 m4">
                        <label>Date of Purchase</label>
                        <div class="detail">{{ mutable_selected_warranty.purchase_date }}</div>
                    </div>
                    <div class="col s12 m4">
                        <label>Reference Code</label>
                        <div class="detail">{{ mutable_selected_warranty.reference_code }}</div>
                    </div>
                    <div class="col s12 m4">
                        <label>Purchase From</label>
                        <div class="detail truncate">{{ mutable_selected_warranty.purchaser == null ? 'Not Available' : mutable_selected_warranty.purchaser.name }}</div>
                    </div>
                    <div class="col s12 m4">
                        <label>Registered At</label>
                        <div class="detail truncate">{{ mutable_selected_warranty.registered_at }}</div>
                    </div>
                    <div class="col s12 m4" v-if="mutable_selected_warranty.status == 1">
                        <label>Warranty End Date</label>
                        <div class="detail truncate">{{ mutable_selected_warranty.warranty_duration }}</div>
                    </div>
                    <div class="col s12">
                        <img class="responsive-img invoice-img materialboxed" :src="mutable_selected_warranty.invoice_image_url">
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <!--<a href="#!" v-on:click.prevent="promptPrint()" class="left waves-effect waves-green btn-flat">Print</a>-->
                <a href="#!" class="modal-close waves-effect waves-green btn-flat">Close</a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "WarrantyTableComponent",
        props: ['warranties', 'user', 'url', 'syncPosItems'],
        data () {
            return{
                mutable_selected_warranty: null,
                is_sync_loading: false
            }
        },
        created () {
            this.mutable_selected_warranty = this.warranties[0]
        },
        mounted () {
            $('.modal').modal();
            $('.materialboxed').materialbox();
        },
        methods : {
            showViewModal (warranty)
            {
                $(this.$refs['viewModal' + this.mutable_selected_warranty.id]).modal();
                this.mutable_selected_warranty = warranty;
            },

            syncData ()
            {
                let me = this;

                this.is_sync_loading = true

                axios.get(this.syncPosItems)
                    .then(function (response) {
                        if (response.data.success)
                        {
                            location.reload();
                        }
                })
                    .catch(function (error){
                    });
            }
        }
    }
</script>

<style scoped>

</style>
